import Input from "../../../design/Input";


function AccountCoupon() {

    return (
        <div className="account-aufa-continer">
            <div className="account-aufa-coupon">
                <p>מס' שובר</p>
                <Input />

                <p>קוד</p>
                <Input />
            </div>
        </div>
    )
}


export default AccountCoupon;